module.exports = __webpack_public_path__ + "img/qq.dda030f9.png";